"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateClientFactory = exports.ClientError = void 0;
var common_1 = require("./common");
var createEndpointClient_1 = __importDefault(require("./createEndpointClient"));
var instance_1 = __importDefault(require("./instance"));
var errors_1 = require("./errors");
Object.defineProperty(exports, "ClientError", { enumerable: true, get: function () { return errors_1.ClientError; } });
var createRouterClient = function (basePath, routerMetadata, instance) {
    var routerPath = (0, common_1.joinPath)(basePath, routerMetadata.path);
    return routerMetadata.children.reduce(function (acc, routerOrEndpointMetadata) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[routerOrEndpointMetadata.name] = routerOrEndpointMetadata.type === 'endpoint'
            ? (0, createEndpointClient_1.default)(routerPath, instance, routerOrEndpointMetadata)
            : createRouterClient(routerPath, routerOrEndpointMetadata, instance), _a)));
    }, {});
};
var generateClientFactory = function (metadata) {
    return function (baseURL, getRequestSettings, clientOptions) {
        if (clientOptions === void 0) { clientOptions = {}; }
        var instance = new instance_1.default(baseURL, getRequestSettings, clientOptions);
        return createRouterClient('', {
            name: '',
            type: 'router',
            path: '',
            children: metadata,
        }, instance);
    };
};
exports.generateClientFactory = generateClientFactory;
//# sourceMappingURL=index.js.map